import React, { useEffect, useState } from 'react';
const RECENT_SALES = [{
  name: 'Daniela',
  province: 'Salta'
}, {
  name: 'María',
  province: 'Buenos Aires'
}, {
  name: 'Juan',
  province: 'Córdoba'
}, {
  name: 'Ana',
  province: 'Mendoza'
}, {
  name: 'Carlos',
  province: 'Tucumán'
}, {
  name: 'Sofía',
  province: 'Santa Fe'
}, {
  name: 'Laura',
  province: 'Entre Ríos'
}, {
  name: 'Diego',
  province: 'Neuquén'
}, {
  name: 'Valentina',
  province: 'Misiones'
}, {
  name: 'Lucía',
  province: 'San Juan'
}, {
  name: 'Martín',
  province: 'Chaco'
}, {
  name: 'Camila',
  province: 'Jujuy'
}, {
  name: 'Andrés',
  province: 'Río Negro'
}, {
  name: 'Florencia',
  province: 'La Plata'
}, {
  name: 'Romina',
  province: 'Mar del Plata'
}, {
  name: 'Agustina',
  province: 'Rosario'
}];
export function SalesPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentSale, setCurrentSale] = useState(RECENT_SALES[0]);
  useEffect(() => {
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    const cycleInterval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        const randomIndex = Math.floor(Math.random() * RECENT_SALES.length);
        setCurrentSale(RECENT_SALES[randomIndex]);
        setIsVisible(true);
      }, 2000);
    }, 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(cycleInterval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-fade-in-up" data-id="element-5">
      <div className="bg-gray-900 rounded-lg shadow-lg p-4 flex items-center gap-3 border-l-4 border-yellow-500 max-w-xs" data-id="element-6">
        <span className="text-2xl flex-shrink-0" aria-hidden="true" data-id="element-7">
          🏆
        </span>
        <p className="text-sm text-gray-200" data-id="element-8">
          <span className="font-bold text-white" data-id="element-9">{currentSale.name}</span> de{' '}
          <span className="font-bold text-white" data-id="element-10">{currentSale.province}</span>{' '}
          compró el{' '}
          <span className="font-bold text-yellow-400" data-id="element-11">Pack Completo</span>{' '}
          <span aria-hidden="true" data-id="element-12">⭐</span>
        </p>
      </div>
    </div>;
}